export default __webpack_public_path__ + "static/media/loading.03bd46d0.svg";